import React, { useEffect, useState } from "react";
import { useDispatch } from "react-redux";

import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import { faCircleNotch } from "@fortawesome/free-solid-svg-icons";

// import DashboardService from "../../services/DashboardService";
import "../usuario-confirmacao/usuario-confirmacao.scss";
// import SubModulos from "../dashboard/subModulo/index";
import { actions } from "../../redux/actions";
import AuthService from "../../services/AuthService"

const Index: React.FC<any> = (props) => {
  const dispatch = useDispatch();

  const [loading, setLoading] = useState(false);

  const [token] = useState(props.match.params.token || "");
  const [email] = useState(props.match.params.email || "");
  const [modulo] = useState(props.match.params.modulo || "");
  const [lastAccess] = useState(props.match.params.lastAccess || "");

  useEffect(() => {
    setLoading(true);
    let currentTokenDate = new Date();
    if (!token || !email) {
      window.location.href = "https://www.ancp.org.br/";
    } else {
      var _user = {
        email: email,
      };
      localStorage.setItem("usuario_ancp", JSON.stringify(_user));
      localStorage.setItem("lastAccess", JSON.stringify(lastAccess));
      localStorage.setItem("currentTokenDate", JSON.stringify( currentTokenDate ));

      AuthService.save_token_storage(token)
    }
    setTimeout(function () {
      setLoading(false);
      window.location.href = "/" + modulo;
    }, 3000);

    dispatch(actions.addNewTitle(""));
    // eslint-disable-next-line
  }, []);

  return (
    <>
      <div className="dashboard-container">
        {loading && (
          <div className={"loading-mask"}>
            <FontAwesomeIcon icon={faCircleNotch} pulse />
          </div>
        )}
        <h4>Redirecionando para o modulo {modulo}</h4>
        {/* <SubModulos /> */}
      </div>
    </>
  );
}

export default Index;